import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Toaster } from 'sonner';
import { App } from './App.tsx';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root not found');

const client = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 3_000, refetchOnWindowFocus: true, retry: 1 },
    mutations: { retry: 0 },
  },
});

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <App />
      <Toaster position="top-center" richColors closeButton />
    </QueryClientProvider>
  </StrictMode>,
);
